import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { palette } from "../../../theme/palette";
import styled from "@emotion/styled";
import { Tabs as MuiTabs } from "@mui/material";
import { useTab } from "./tabContext";
const StyledTabs = styled(MuiTabs)(({ color, style, size }) => ({
    minHeight: (size === "medium" && "30px") || (size === "large" && "34px") || "auto",
    ".MuiTabs-indicator": {
        backgroundColor: palette[color],
        height: "4px",
    },
    ".Mui-selected": {
        color: `${palette[color]} !important`,
    },
    ".MuiTouchRipple-child": {
        backgroundColor: `${palette[color]} !important`,
    },
    ".MuiTabs-scrollButtons": {
        display: "flex",
        alignItems: "flex-start",
        color: palette.grey050,
    },
    ...style,
}));
export const Tabs = ({ children, size = "medium", variant = "standard", ...props }) => {
    const { value, color } = useTab();
    return (_jsx(StyledTabs, { ...props, value: value, draggable: false, color: color, size: size, variant: variant, scrollButtons: false, children: children }));
};
//# sourceMappingURL=Tabs.js.map